if (!customElements.get('product-page-bundle')) {
  customElements.define(
    'product-page-bundle',
    class ProductPageBundle extends HTMLElement {
      
    constructor() {
      super();
      
      this.selectors = {
        addToCartText: '[data-pp-bundle-add-to-cart-text]',
        addToCartTextContent: '[data-pp-bundle-add-to-cart-text-content]',
        bundleAddToCart: '[data-pp-bundle-add-to-cart]',
        bundleItem: '[data-pp-bundle-item]',
        bundleItemImage: '[data-pp-bundle-item-image]',
        bundleItemPropertyTitle: '[data-pp-bundle-item-property-title]',
        bundleItemPropertyToken: '[data-pp-bundle-item-property-token]',
        bundleItemQuickViewTrigger: '[data-pp-bundle-item-quickview-trigger]',
        bundleItemSelector: '[data-pp-bundle-item-selector]',
        bundlePrice: '[data-pp-bundle-price]',
        error: '[data-pp-bundle-error]',
        errorMessage: '[data-pp-bundle-error-message]',
        errors: '[data-pp-bundle-errors]',
        modalContent: '[data-modal-content]',
        quickView: '#ProductPageBundleQuickView',
        quickViewContent: '[data-pp-bundle-quickview-content]',
        stickyAddToCart: '[data-pp-bundle-sticky-add-to-cart]'
      };
    
      this.classes = {
        active: 'active',
        ajaxLoading: 'ajax--loading',
        quickViewHidden: 'pp-bundle__item-quickview--hidden',
        formPostedSuccess: 'form-posted--success',
        formPostedError: 'form-posted--error',
        hidden: 'hidden',
        imageIsLoading: 'image--is-loading'
      };
      
      this.data = {
        itemIndex: 'itemIndex',
        productHandle: 'productHandle',
        productTitle: 'productTitle',
        variantId: 'variantId'
      };

      this.attr = {
        itemIndex: 'data-item-index',
        productHandle: 'data-product-handle',
        productTitle: 'data-product-title',
        variantId: 'data-variant-id'
      };
    
      this.mqlMobile = window.matchMedia('(max-width: 749px)');
      
      if (!document.getElementById('ProductPageBundleJson')) return;
  
      this.bundleData = JSON.parse(
        document.getElementById('ProductPageBundleJson').innerHTML
      );

      this.cache = {};
      
      this._cacheSelectors();
      
      this._initEvents();
      this._checkURL();
      this._generateToken();
      
    }

    _cacheSelectors() {
      this.cache.$addToCart = this.querySelector(this.selectors.bundleAddToCart);
      this.cache.$bundleItemSelector = this.querySelectorAll(this.selectors.bundleItemSelector);
      this.cache.$bundleItemPropertyTitle = this.querySelectorAll(this.selectors.bundleItemPropertyTitle);
      this.cache.$bundleItemPropertyToken = this.querySelectorAll(this.selectors.bundleItemPropertyToken);
      this.cache.$bundleItemQuickViewTrigger = this.querySelectorAll(this.selectors.bundleItemQuickViewTrigger);
      this.cache.$quickView = this.querySelector(this.selectors.quickView);
      this.cache.$stickyAddToCart = this.querySelector(this.selectors.stickyAddToCart);
      
    }

    _initEvents() {
      this.cache.$bundleItemSelector.forEach($bis => $bis.addEventListener('change', this._onBundleItemSelectorChange.bind(this)));
      document.addEventListener('selectBundleProducts.ppbundle', this._onSelectBundleProducts);      
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      document.addEventListener('selectBundleProducts.ppbundle', this._onSelectBundleProducts);

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form') {
          this._generateToken();
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('selectBundleProducts.ppbundle', this._onSelectBundleProducts);

      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    _checkURL() {
      const urlParams = new URLSearchParams(window.location.search);

      if (!urlParams.has('addbundle')) return;

      var productHandles = urlParams.get('addbundle').split(',');

      this._selectBundleProducts(productHandles);
      
      this.cache.$bundleItemSelector.forEach($bis => $bis.dispatchEvent(new Event('change')));
      
    }

    _onSelectBundleProducts = (evt) => {
      let productHandles = evt.detail.productHandles;

      this._selectBundleProducts(productHandles);
      
      this.cache.$bundleItemSelector.forEach($bis => $bis.dispatchEvent(new Event('change')));
      
    }
    
    _selectBundleProducts(productHandles) {
      productHandles.forEach(
        function(productHandle, index) {
          let $selector = this.querySelector(
            `${this.selectors.bundleItem}[${this.attr.itemIndex}="${++index}"] ${this.selectors.bundleItemSelector}`
           );

          if ($selector) {
            let $option = $selector.querySelector(`option[${this.attr.productHandle}="${productHandle}"]`);
  
            if ($option && !$option.disabled) {
              $selector.querySelectorAll('option').forEach(o => o.selected = false);
              $option.selected = true;
            }
          }
          
        }.bind(this)
      );
      
    }
    
    _onBundleItemSelectorChange(evt) {
      const $selector = evt.currentTarget;
      const $bundleItem = $selector.closest(this.selectors.bundleItem);
      const $quickViewTrigger = $bundleItem.querySelector(this.selectors.bundleItemQuickViewTrigger);
      const index = $bundleItem.dataset[this.data.itemIndex];
      const $selectedOption = [...$selector.options].find($option => $option.value == $selector.value);

      const variantId = $selectedOption.dataset[this.data.variantId] || false;
      const productTitle = $selectedOption.dataset[this.data.productTitle] || '';
      const productHandle = $selectedOption.dataset[this.data.productHandle] || '';

      if (!variantId) {
        $quickViewTrigger.classList.add(this.classes.quickViewHidden);
        
        return;
      
      } else {
        this.cache.$bundleItemPropertyTitle[index - 1].value = productTitle;

        $quickViewTrigger.dataset[this.data.productHandle] = productHandle;
        $quickViewTrigger.classList.remove(this.classes.quickViewHidden);
        
      }
 
      const bundleItemData = this.bundleData.bundleProducts.filter(item => item.variantId == variantId)[0];

      this._updateBundleItemImage($bundleItem, bundleItemData.image);
      this._toggleAddToCart();
      
    }

    _createBundleItemImage(imageData) {
      const sizes = '(min-width: 990px) 165px, (min-width: 750px) calc((40vw - 15px) / 2), calc((100vw - 40px) / 2)';
      const sizeset = ['165', '360', '533'];
      
      let image = document.createElement('img');

      let srcset = [];
      for (let i in sizeset) {
        let size = sizeset[i];
        srcset.push(
          `${imageData.src}&width=${size} ${size}w`
        );
      }

      srcset.push(`${imageData.src} ${imageData.width}w`);
      srcset.join(', ');

      image.srcset = srcset;
      image.src = `${imageData.src}&width=360`;
      image.sizes = sizes;
      image.alt = imageData.alt;
      image.width = imageData.width;
      image.height = imageData.height;
      
      return image;
    
    }

    _updateBundleItemImage($item, image) {
      if (!image) return;
      let $imageContainer = $item.querySelector(this.selectors.bundleItemImage);

      $imageContainer
        .classList.add(this.classes.imageIsLoading);

      let $image = this._createBundleItemImage(image);

      $image.addEventListener('load', () => {
        $imageContainer.innerHTML = $image.outerHTML;
        $imageContainer.classList.remove(this.classes.imageIsLoading);             
      });

    }

    _enableAddToCart() {
      this.cache.$addToCart.removeAttribute('aria-disabled');
      this.cache.$addToCart.disabled = false;
      
    }

    _disableAddToCart() {
      this.cache.$addToCart.setAttribute('aria-disabled', true);
      this.cache.$addToCart.disabled = true;

    }

    _toggleAddToCart() {
      let allSelected = true;
      this.cache.$bundleItemSelector.forEach($bis => { if (!parseInt($bis.value)) allSelected = false });
      
      if (allSelected) {
        this._enableAddToCart();
      } else {
        this._disableAddToCart();
      }
    }

    _generateToken() {
      const a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
      let b = [];
      for (let i=0; i<10; i++) {
        var j = (Math.random() * (a.length-1)).toFixed(0);
        b[i] = a[j];
      }
      const token = b.join("");

      this.cache.$bundleItemPropertyToken.forEach($bipt => $bipt.value = token);
    }

    }
  );
}

if (!customElements.get('product-page-bundle-modal')) {
  customElements.define(
    'product-page-bundle-modal',
    class ProductPageBundleModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="PPBundleModalInfo-"]');
      }
      
      hide(preventFocus = false) {
        if (preventFocus) this.openedBy = null;
        super.hide();        
      }

      show(opener) {
        if (!opener.dataset.productHandle) return;
        this.modalContent.innerHTML = '';
        this.setAttribute('loading', '');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        super.show(opener);      
        console.log(`/products/${opener.dataset.productHandle}?section_id=product-page-bundle-quickview`);
        fetch(`/products/${opener.dataset.productHandle}?section_id=product-page-bundle-quickview`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.modalContent.innerHTML = responseHTML.querySelector('.shopify-section').innerHTML;
          
          })
          .finally(() => {
            this.removeAttribute('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
          })
        
      }
      
    }
  )
}